import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppComponent } from '../app.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  private readonly baseUrl: string;
  
  constructor(
    private readonly http: HttpClient,
  ) { 
    this.baseUrl = AppComponent.testUrl;
  }

  getVariable(nombreVariable: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/seguro/variables/${nombreVariable}`);
  }
}
